import { motion } from "framer-motion";
import { Gift as GiftIcon } from "lucide-react";

export const Gift = ({ onGift }) => (
  <section id="gift" className="border-t border-ink/10 bg-wine py-24 text-paper md:py-32" data-testid="gift-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:grid-cols-[1.4fr_1fr] md:px-12">
      <div>
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-xs uppercase tracking-[0.35em] text-gold"
        >
          For the wine person in your life
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 font-serif text-4xl tracking-tight md:text-6xl"
        >
          Gift the club. <em>It costs you nothing to give.</em>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-8 max-w-md text-sm leading-relaxed text-paper/70 md:text-base"
        >
          Membership is free — so gifting it is too. Sign them up, pick their
          style, and let the bottles do the talking. Add Premium later if you
          want to spoil them properly.
        </motion.p>
        <motion.button
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          data-testid="gift-cta-button"
          onClick={onGift}
          className="mt-10 flex items-center gap-3 rounded-full bg-paper px-8 py-4 text-sm uppercase tracking-widest text-wine transition-colors duration-300 hover:bg-gold hover:text-ink"
        >
          <GiftIcon className="h-4 w-4" />
          Gift a free membership
        </motion.button>
      </div>
      <motion.img
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.2 }}
        src="https://images.unsplash.com/photo-1592119748016-a61c40a44320?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
        alt="A bottle of wine, ready to gift"
        className="hidden aspect-[4/5] w-full object-cover md:block"
        style={{ clipPath: "polygon(6% 0, 100% 0, 94% 100%, 0 100%)" }}
      />
    </div>
  </section>
);
